<template>
  <svg class="icon heart" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15">
    <path d="M15 4.904c0-1.933-1.633-3.5-3.646-3.5-1.505 0-2.798.876-3.354 2.126-.556-1.25-1.849-2.126-3.355-2.126C2.633 1.404 1 2.971 1 4.904c0 5.616 7 9.334 7 9.334s7-3.718 7-9.334Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
